import { create } from 'zustand';

export const useSalesRepViewStore = create((set, get) => ({
  isBannerClosed: false,
  closeBanner: () => set(() => ({ isBannerClosed: true })),
  isConfirmationOpen: false,
  closeConfirmation: () => set(() => ({ isConfirmationOpen: false })),
  openConfirmation: () => set(() => ({ isConfirmationOpen: true })),
}));
